import { Component } from '@angular/core';
import { IonLoading } from '@ionic/angular';
import { LoadingService } from '@bling-fe/shared/services';

@Component({
  selector: 'fl-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false
})
export class LoadingComponent {
  isOpen = this.loadingService.isLoading;

  constructor(private loadingService: LoadingService) {}

  dismissUnlessLoading(loading: IonLoading) {
    if (!this.isOpen()) {
      loading.dismiss();
    }
  }
}
